/**
 *
 * @module subscriptionSourceSubType
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef SubscriptionSourceSubType
 * @type {Object}
 *
 * @property {String} GIFT_SUB
 * @property {String} GIFT_CARD
 * @property {String} PAID
 * @property {String} PROMO_REDEMPTION
 * @property {String} COMP
 * @property {String} TEMP
 * @property {String} OTHER
 *
 */

/**
 *
 * @enum
 * @type {SubscriptionSourceSubType}
 *
 */
export default KeyMirror({
    /**
     *
     * @access private
     * @type {String}
     *
     */
    GIFT_SUB: null,
    /**
     *
     * @access private
     * @type {String}
     *
     */
    GIFT_CARD: null,
    /**
     *
     * @access private
     * @type {String}
     *
     */
    PAID: null,
    /**
     *
     * @access private
     * @type {String}
     *
     */
    PROMO_REDEMPTION: null,
    /**
     *
     * @access private
     * @type {String}
     *
     */
    COMP: null,
    /**
     *
     * @access private
     * @type {String}
     *
     */
    TEMP: null,
    /**
     *
     * @access private
     * @type {String}
     *
     */
    OTHER: null
});



// WEBPACK FOOTER //
// ./src/services/subscription/subscriptionSourceSubType.js